var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmutable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m369.484375 96.765625-85.019531-85.023437c-7.792969-7.792969-15.859375-11.742188-23.976563-11.742188-12.382812 0-24.882812 9.890625-24.882812 31.980469v23.378906c-120.710938 7.128906-220.640625 99.765625-235.492188 221.050781-.832031 6.773438 3.019531 13.257813 9.367188 15.769532 1.796875.710937 3.667969 1.054687 5.515625 1.054687 4.679687 0 9.21875-2.191406 12.109375-6.140625 39.835937-54.429688 103.796875-86.925781 171.09375-86.925781 12.472656 0 25.007812 1.125 37.40625 3.351562v25.742188c0 8.175781 1.636719 15.035156 4.855469 20.378906 4.445312 7.375 11.742187 11.601563 20.027343 11.601563 8.117188 0 16.183594-3.953126 23.976563-11.742188l85.019531-85.023438c18.667969-18.667968 18.667969-49.046874 0-67.710937zm0 0",
    fill: "#00d8e0",
    "data-original": "#00d8e0"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m438.257812 219.820312c-6.351562-2.511718-13.59375-.417968-17.625 5.089844-39.835937 54.425782-103.796874 86.921875-171.09375 86.921875-12.46875 0-25.003906-1.125-37.40625-3.351562v-25.742188c0-22.089843-12.496093-31.980469-24.882812-31.980469-8.117188 0-16.183594 3.953126-23.972656 11.746094l-85.023438 85.019532c-18.667968 18.667968-18.667968 49.042968 0 67.714843l85.023438 85.019531c7.789062 7.792969 15.855468 11.742188 23.972656 11.742188 12.386719 0 24.882812-9.890625 24.882812-31.980469v-23.378906c120.714844-7.128906 220.644532-99.765625 235.492188-221.046875.832031-6.777344-3.019531-13.261719-9.367188-15.773438zm0 0",
    fill: "#54e360",
    "data-original": "#54e360"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m235.605469 229.261719c0 8.175781 1.636719 15.035156 4.855469 20.378906 4.445312 7.375 11.742187 11.601563 20.027343 11.601563 8.117188 0 16.183594-3.953126 23.976563-11.742188l85.019531-85.023438c18.667969-18.667968 18.667969-49.042968 0-67.710937l-85.019531-85.023437c-7.792969-7.792969-15.859375-11.742188-23.976563-11.742188-12.382812 0-24.882812 9.890625-24.882812 31.980469v23.378906c-3.933594.234375-7.847657.5625-11.738281.976563v145.421874c3.921874.484376 7.839843 1.0625 11.738281 1.761719zm0 0",
    fill: "#00acb3",
    "data-original": "#00acb3"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m438.257812 219.820312c-6.351562-2.511718-13.59375-.417968-17.625 5.089844-39.835937 54.425782-103.796874 86.921875-171.09375 86.921875-8.546874 0-17.125-.542969-25.671874-1.589843v145.421874c115.402343-12.226562 209.390624-102.742187 223.757812-220.070312.832031-6.777344-3.019531-13.261719-9.367188-15.773438zm0 0",
    fill: "#00ab5e",
    "data-original": "#00ab5e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmutable);
export default __webpack_public_path__ + "static/media/immutable.0a7d1ac590ed32d57a4854a44cb80665.svg";
export { ForwardRef as ReactComponent };